module.exports = __webpack_public_path__ + "static/img/kol-national.491fe54b.png";